// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_outer-container__HmLvv{
    width:100vw;
    height:25vw;
    background-color:#e65439;
    padding-left:3vw;
    box-sizing: border-box;
    display:flex;
}


.Footer_container-one__u5OqR{
    margin-top: 1.5vw;
    height: max-content;
    width: max-content;
}

.Footer_footer-img__KoGh3{
    width: 12vw;
    height: 4.2vw;
}

.Footer_footer-desc__SS8JF{
    width: 60%;
    word-break: break-word;
    color: white;
    font-size: 1.2vw;
    margin-left: 1.4vw;
    font-family: dm-sans-medium;
}

.Footer_div-1__J61mE{
    display: flex;
    flex-direction: column;
    color:white;
    font-size: 1.2vw;
    margin-top: 4vw;
    margin-left: -15vw;
    position: relative;
    z-index: 1;
}

.Footer_div-2__nD8OA{
    display: flex;
    flex-direction: column;
    color:white;
    font-size: 1.2vw;
    margin-top: 4vw;
    margin-left: 5vw;
    position: relative;
    z-index: 1;
}

.Footer_footer-bg-container__tg8N9{
    width: 97vw;
    height: 20vw;
    position: absolute;
    margin-left: auto;
    margin-top: 5vw;
    overflow: hidden;
    z-index: 0;
}

.Footer_footer-bg-img__SMiXE{
    width: 40vw;
    height: 20vw;
    margin-left: 60vw;
    /* margin-top: auto;
    margin-left: auto; */
}

@media(max-width: 768px){
    .Footer_outer-container__HmLvv{
        height:55vw;
        background-color:#e65439;
        padding-left:0vw;
        display:flex;
        flex-direction: column;
    }
    
    
    /* .container-one{
        margin-top: 1.5vw;
        height: max-content;
        width: max-content;
    } */
    
    .Footer_footer-img__KoGh3{
        width: 25vw;
        height: 9vw;
    }
    
    .Footer_footer-desc__SS8JF{
        display: none;
        width: 60%;
        word-break: break-word;
        color: white;
        font-size: 1.2vw;
        margin-left: 1.4vw;
    }
    
    .Footer_div-1__J61mE{
        position: absolute;
        display: flex;
        flex-direction: column;
        color:white;
        font-size: 3vw;
        margin-top: 12vw;
        margin-left: 3vw;
    }
    
    .Footer_div-2__nD8OA{
        position:absolute;
        display: flex;
        flex-direction: column;
        color:white;
        font-size: 3vw;
        margin-top: 12vw;
        margin-left: 30vw;
    }

    .Footer_footer-bg-container__tg8N9{
        width: 100%;
        height: 35vw;
        position: absolute;
        margin-left: auto;
        margin-top: 20vw;
        overflow: hidden;
    }
    
    .Footer_footer-bg-img__SMiXE{
        width: 60%;
        height: 100%;
        margin-left: 45vw;
        /* width: 60%;
        height: 35vw; */
        /* position: absolute; */
        /* object-fit: contain; */
        /* margin-top: 20vw;
        margin-left: 40vw;  */
    }
}

`, "",{"version":3,"sources":["webpack://./src/Global/Footer/Footer.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,WAAW;IACX,wBAAwB;IACxB,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;AAChB;;;AAGA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB;wBACoB;AACxB;;AAEA;IACI;QACI,WAAW;QACX,wBAAwB;QACxB,gBAAgB;QAChB,YAAY;QACZ,sBAAsB;IAC1B;;;IAGA;;;;OAIG;;IAEH;QACI,WAAW;QACX,WAAW;IACf;;IAEA;QACI,aAAa;QACb,UAAU;QACV,sBAAsB;QACtB,YAAY;QACZ,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,WAAW;QACX,cAAc;QACd,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,sBAAsB;QACtB,WAAW;QACX,cAAc;QACd,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,iBAAiB;QACjB,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,UAAU;QACV,YAAY;QACZ,iBAAiB;QACjB;uBACe;QACf,wBAAwB;QACxB,yBAAyB;QACzB;6BACqB;IACzB;AACJ","sourcesContent":[".outer-container{\n    width:100vw;\n    height:25vw;\n    background-color:#e65439;\n    padding-left:3vw;\n    box-sizing: border-box;\n    display:flex;\n}\n\n\n.container-one{\n    margin-top: 1.5vw;\n    height: max-content;\n    width: max-content;\n}\n\n.footer-img{\n    width: 12vw;\n    height: 4.2vw;\n}\n\n.footer-desc{\n    width: 60%;\n    word-break: break-word;\n    color: white;\n    font-size: 1.2vw;\n    margin-left: 1.4vw;\n    font-family: dm-sans-medium;\n}\n\n.div-1{\n    display: flex;\n    flex-direction: column;\n    color:white;\n    font-size: 1.2vw;\n    margin-top: 4vw;\n    margin-left: -15vw;\n    position: relative;\n    z-index: 1;\n}\n\n.div-2{\n    display: flex;\n    flex-direction: column;\n    color:white;\n    font-size: 1.2vw;\n    margin-top: 4vw;\n    margin-left: 5vw;\n    position: relative;\n    z-index: 1;\n}\n\n.footer-bg-container{\n    width: 97vw;\n    height: 20vw;\n    position: absolute;\n    margin-left: auto;\n    margin-top: 5vw;\n    overflow: hidden;\n    z-index: 0;\n}\n\n.footer-bg-img{\n    width: 40vw;\n    height: 20vw;\n    margin-left: 60vw;\n    /* margin-top: auto;\n    margin-left: auto; */\n}\n\n@media(max-width: 768px){\n    .outer-container{\n        height:55vw;\n        background-color:#e65439;\n        padding-left:0vw;\n        display:flex;\n        flex-direction: column;\n    }\n    \n    \n    /* .container-one{\n        margin-top: 1.5vw;\n        height: max-content;\n        width: max-content;\n    } */\n    \n    .footer-img{\n        width: 25vw;\n        height: 9vw;\n    }\n    \n    .footer-desc{\n        display: none;\n        width: 60%;\n        word-break: break-word;\n        color: white;\n        font-size: 1.2vw;\n        margin-left: 1.4vw;\n    }\n    \n    .div-1{\n        position: absolute;\n        display: flex;\n        flex-direction: column;\n        color:white;\n        font-size: 3vw;\n        margin-top: 12vw;\n        margin-left: 3vw;\n    }\n    \n    .div-2{\n        position:absolute;\n        display: flex;\n        flex-direction: column;\n        color:white;\n        font-size: 3vw;\n        margin-top: 12vw;\n        margin-left: 30vw;\n    }\n\n    .footer-bg-container{\n        width: 100%;\n        height: 35vw;\n        position: absolute;\n        margin-left: auto;\n        margin-top: 20vw;\n        overflow: hidden;\n    }\n    \n    .footer-bg-img{\n        width: 60%;\n        height: 100%;\n        margin-left: 45vw;\n        /* width: 60%;\n        height: 35vw; */\n        /* position: absolute; */\n        /* object-fit: contain; */\n        /* margin-top: 20vw;\n        margin-left: 40vw;  */\n    }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"outer-container": `Footer_outer-container__HmLvv`,
	"container-one": `Footer_container-one__u5OqR`,
	"footer-img": `Footer_footer-img__KoGh3`,
	"footer-desc": `Footer_footer-desc__SS8JF`,
	"div-1": `Footer_div-1__J61mE`,
	"div-2": `Footer_div-2__nD8OA`,
	"footer-bg-container": `Footer_footer-bg-container__tg8N9`,
	"footer-bg-img": `Footer_footer-bg-img__SMiXE`
};
export default ___CSS_LOADER_EXPORT___;
